module.exports = __webpack_public_path__ + "78e94cad46e50cb14587148efe30f8cd.pdf";